module.exports = __webpack_public_path__ + "ae7e04ee050b612af5e5be18d2cd87ec.svg";